// Translation strings for English and Hindi
export const translations = {
  en: {
    title: 'Registration Form',
    name: 'Name',
    mobileNumber: 'Mobile Number',
    whatsappQuestion: 'Is this your WhatsApp number?',
    gender: 'Gender',
    male: 'Male',
    female: 'Female',
    other: 'Other',
    age: 'Age (in years)',
    occupation: 'Occupation',
    business: 'Business',
    privateJob: 'Private Job',
    governmentJob: 'Government Job',
    selfEmployed: 'Self Employed',
    selectOccupation: 'Select Occupation',
    state: 'State of Residence',
    district: 'District of Residence',
    selectState: 'Select State',
    selectDistrict: 'Select District',
    submit: 'Register',
    yes: 'Yes',
    no: 'No',
    required: 'This field is required',
    invalidMobile: 'Mobile number must be 10 digits',
    invalidAge: 'Age must be between 18 and 100',
    registrationSuccess: 'Registration Successful!',
    registrationDetails: 'Registration Details',
    print: 'Print',
    newRegistration: 'New Registration',
    errors: {
      nameRequired: 'Name is required',
      mobileRequired: 'Mobile number is required',
      genderRequired: 'Gender is required',
      ageRequired: 'Age is required',
      occupationRequired: 'Occupation is required',
      stateRequired: 'State is required',
      districtRequired: 'District is required'
    }
  },
  hi: {
    title: 'पंजीकरण फॉर्म',
    name: 'नाम',
    mobileNumber: 'मोबाइल नंबर',
    whatsappQuestion: 'क्या यह आपका व्हाट्सएप नंबर है?',
    gender: 'लिंग',
    male: 'पुरुष',
    female: 'महिला',
    other: 'अन्य',
    age: 'आयु (वर्ष में)',
    occupation: 'व्यवसाय',
    business: 'व्यापार',
    privateJob: 'निजी नौकरी',
    governmentJob: 'सरकारी नौकरी',
    selfEmployed: 'स्वरोजगार',
    selectOccupation: 'व्यवसाय चुनें',
    state: 'आपके निवास स्थान का राज्य',
    district: 'आपके निवास स्थान का जिला',
    selectState: 'राज्य चुनें',
    selectDistrict: 'जिला चुनें',
    submit: 'पंजीकृत करें',
    yes: 'हाँ',
    no: 'नहीं',
    required: 'यह फ़ील्ड आवश्यक है',
    invalidMobile: 'मोबाइल नंबर 10 अंकों का होना चाहिए',
    invalidAge: 'आयु 18 से 100 के बीच होनी चाहिए',
    registrationSuccess: 'पंजीकरण सफल!',
    registrationDetails: 'विवरण',
    print: 'प्रिंट करें',
    newRegistration: 'नया पंजीकरण',
    errors: {
      nameRequired: 'नाम आवश्यक है',
      mobileRequired: 'मोबाइल नंबर आवश्यक है',
      genderRequired: 'लिंग आवश्यक है',
      ageRequired: 'आयु आवश्यक है',
      occupationRequired: 'व्यवसाय आवश्यक है',
      stateRequired: 'राज्य आवश्यक है',
      districtRequired: 'जिला आवश्यक है'
    }
  }
};

// State and District mapping
export const stateDistrictData = {
  'Andhra Pradesh': {
    hi: 'आंध्र प्रदेश',
    districts: {
      en: ['Visakhapatnam', 'Vijayawada', 'Guntur', 'Nellore', 'Kurnool', 'Tirupati', 'Kakinada', 'Rajahmundry', 'Anantapur', 'Kadapa'],
      hi: ['विशाखापट्नम', 'विजयवाड़ा', 'गुंटूर', 'नेल्लोर', 'कुर्नूल', 'तिरुपति', 'काकिनाडा', 'राजमुंद्री', 'अनंतपुर', 'कडपा']
    }
  },
  'Arunachal Pradesh': {
    hi: 'अरुणाचल प्रदेश',
    districts: {
      en: ['Itanagar', 'Papum Pare', 'Changlang', 'Lohit', 'East Siang', 'West Siang', 'Tawang', 'West Kameng', 'East Kameng', 'Lower Subansiri'],
      hi: ['ईटानगर', 'पपुम पारे', 'चांगलांग', 'लोहित', 'पूर्वी सियांग', 'पश्चिमी सियांग', 'तवांग', 'पश्चिम कमेंग', 'पूर्व कमेंग', 'लोअर सुबनसिरी']
    }
  },
  'Assam': {
    hi: 'असम',
    districts: {
      en: ['Guwahati', 'Kamrup', 'Dibrugarh', 'Jorhat', 'Silchar', 'Nagaon', 'Tezpur', 'Barpeta', 'Goalpara', 'Tinsukia'],
      hi: ['गुवाहाटी', 'कामरूप', 'डिब्रूगढ़', 'जोरहाट', 'सिलचर', 'नगांव', 'तेजपुर', 'बारपेटा', 'गोआलपारा', 'तिनसुकिया']
    }
  },
  'Bihar': {
    hi: 'बिहार',
    districts: {
      en: ['Araria', 'Arwal', 'Aurangabad', 'Banka', 'Begusarai', 'Bhagalpur', 'Bhojpur', 'Buxar', 'Darbhanga', 'East Champaran', 'Gaya', 'Gopalganj', 'Jamui', 'Jehanabad', 'Kaimur', 'Katihar', 'Khagaria', 'Kishanganj', 'Lakhisarai', 'Madhepura', 'Madhubani', 'Munger', 'Muzaffarpur', 'Nalanda', 'Nawada', 'Patna', 'Purnia', 'Rohtas', 'Saharsa', 'Samastipur', 'Saran', 'Sheikhpura', 'Sheohar', 'Sitamarhi', 'Siwan', 'Supaul', 'Vaishali', 'West Champaran'],
      hi: ['अररिया', 'अरवल', 'औरंगाबाद', 'बाँका', 'बेगूसराय', 'भागलपुर', 'भोजपुर', 'बक्सर', 'दरभंगा', 'पूर्वी चम्पारण', 'गया', 'गोपालगंज', 'जमुई', 'जहानाबाद', 'कैमूर', 'कटिहार', 'खगड़िया', 'किशनगंज', 'लखीसराय', 'मधेपुरा', 'मधुबनी', 'मुंगेर', 'मुजफ्फरपुर', 'नालंदा', 'नवादा', 'पटना', 'पूर्णिया', 'रोहतास', 'सहरसा', 'समस्तीपुर', 'सारण', 'शेखपुरा', 'शिवहर', 'सीतामढ़ी', 'सीवान', 'सुपौल', 'वैशाली', 'पश्चिम चम्पारण']
    }
  },
  'Chhattisgarh': {
    hi: 'छत्तीसगढ़',
    districts: {
      en: ['Raipur', 'Bilaspur', 'Durg', 'Bhilai', 'Korba', 'Rajnandgaon', 'Jagdalpur', 'Raigarh', 'Ambikapur', 'Dhamtari'],
      hi: ['रायपुर', 'बिलासपुर', 'दुर्ग', 'भिलाई', 'कोरबा', 'राजनांदगांव', 'जगदलपुर', 'रायगढ़', 'अंबिकापुर', 'धमतरी']
    }
  },
  'Delhi': {
    hi: 'दिल्ली',
    districts: {
      en: ['Central Delhi', 'North Delhi', 'South Delhi', 'East Delhi', 'North East Delhi', 'South West Delhi', 'New Delhi', 'North West Delhi', 'West Delhi', 'South East Delhi', 'Shahdara'],
      hi: ['मध्य दिल्ली', 'उत्तर दिल्ली', 'दक्षिण दिल्ली', 'पूर्व दिल्ली', 'उत्तर पूर्व दिल्ली', 'दक्षिण पश्चिम दिल्ली', 'नई दिल्ली', 'उत्तर पश्चिम दिल्ली', 'पश्चिम दिल्ली', 'दक्षिण पूर्व दिल्ली', 'शाहदरा']
    }
  },
  'Goa': {
    hi: 'गोवा',
    districts: {
      en: ['North Goa', 'South Goa'],
      hi: ['उत्तर गोवा', 'दक्षिण गोवा']
    }
  },
  'Gujarat': {
    hi: 'गुजरात',
    districts: {
      en: ['Ahmedabad', 'Surat', 'Vadodara', 'Rajkot', 'Gandhinagar', 'Bhavnagar', 'Jamnagar', 'Junagadh', 'Anand', 'Bharuch'],
      hi: ['अहमदाबाद', 'सूरत', 'वडोदरा', 'राजकोट', 'गांधीनगर', 'भावनगर', 'जामनगर', 'जूनागढ़', 'आनंद', 'भरूच']
    }
  },
  'Haryana': {
    hi: 'हरियाणा',
    districts: {
      en: ['Gurgaon', 'Faridabad', 'Rohtak', 'Hisar', 'Panipat', 'Karnal', 'Sonipat', 'Ambala', 'Yamunanagar', 'Bhiwani'],
      hi: ['गुरुग्राम', 'फरीदाबाद', 'रोहतक', 'हिसार', 'पानीपत', 'करनाल', 'सोनीपत', 'अंबाला', 'यमुनानगर', 'भिवानी']
    }
  },
  'Himachal Pradesh': {
    hi: 'हिमाचल प्रदेश',
    districts: {
      en: ['Shimla', 'Mandi', 'Kangra', 'Hamirpur', 'Una', 'Bilaspur', 'Chamba', 'Kullu', 'Solan', 'Sirmaur'],
      hi: ['शिमला', 'मंडी', 'कांगड़ा', 'हमीरपुर', 'ऊना', 'बिलासपुर', 'चंबा', 'कुल्लू', 'सोलन', 'सिरमौर']
    }
  },
  'Jharkhand': {
    hi: 'झारखंड',
    districts: {
      en: ['Ranchi', 'Jamshedpur', 'Dhanbad', 'Bokaro', 'Hazaribagh', 'Giridih', 'Ramgarh', 'Deoghar', 'Dumka', 'Palamu'],
      hi: ['रांची', 'जमशेदपुर', 'धनबाद', 'बोकारो', 'हजारीबाग', 'गिरिडीह', 'रामगढ़', 'देवघर', 'दुमका', 'पलामू']
    }
  },
  'Karnataka': {
    hi: 'कर्नाटक',
    districts: {
      en: ['Bangalore Urban', 'Bangalore Rural', 'Mysore', 'Mangalore', 'Hubli-Dharwad', 'Belgaum', 'Gulbarga', 'Shimoga', 'Tumkur', 'Udupi'],
      hi: ['बैंगलोर शहरी', 'बैंगलोर ग्रामीण', 'मैसूर', 'मैंगलोर', 'हुबली-धारवाड़', 'बेलगाम', 'गुलबर्गा', 'शिमोगा', 'तुमकूर', 'उडुपी']
    }
  },
  'Kerala': {
    hi: 'केरल',
    districts: {
      en: ['Thiruvananthapuram', 'Kochi', 'Kozhikode', 'Thrissur', 'Kottayam', 'Kollam', 'Palakkad', 'Malappuram', 'Kannur', 'Alappuzha'],
      hi: ['तिरुवनंतपुरम', 'कोच्चि', 'कोझिकोड', 'त्रिशूर', 'कोट्टायम', 'कोल्लम', 'पलक्कड़', 'मलप्पुरम', 'कन्नूर', 'अलप्पुझा']
    }
  },
  'Madhya Pradesh': {
    hi: 'मध्य प्रदेश',
    districts: {
      en: ['Bhopal', 'Indore', 'Jabalpur', 'Gwalior', 'Ujjain', 'Sagar', 'Dewas', 'Satna', 'Ratlam', 'Rewa'],
      hi: ['भोपाल', 'इंदौर', 'जबलपुर', 'ग्वालियर', 'उज्जैन', 'सागर', 'देवास', 'सतना', 'रतलाम', 'रीवा']
    }
  },
  'Maharashtra': {
    hi: 'महाराष्ट्र',
    districts: {
      en: ['Ahmednagar', 'Akola', 'Amravati', 'Aurangabad', 'Beed', 'Bhandara', 'Buldhana', 'Chandrapur', 'Dhule', 'Gadchiroli', 'Gondia', 'Hingoli', 'Jalgaon', 'Jalna', 'Kolhapur', 'Latur', 'Mumbai City', 'Mumbai Suburban', 'Nagpur', 'Nanded', 'Nandurbar', 'Nashik', 'Osmanabad', 'Palghar', 'Parbhani', 'Pune', 'Raigad', 'Ratnagiri', 'Sangli', 'Satara', 'Sindhudurg', 'Solapur', 'Thane', 'Wardha', 'Washim', 'Yavatmal'],
      hi: ['अहमदनगर', 'अकोला', 'अमरावती', 'औरंगाबाद', 'बीड', 'भंडारा', 'बुलढाणा', 'चंद्रपुर', 'धुले', 'गडचिरोली', 'गोंदिया', 'हिंगोली', 'जलगाँव', 'जालना', 'कोल्हापुर', 'लातूर', 'मुंबई शहर', 'मुंबई उपनगर', 'नागपुर', 'नांदेड़', 'नंदुरबार', 'नाशिक', 'उस्मानाबाद', 'पालघर', 'परभणी', 'पुणे', 'रायगड', 'रत्नागिरी', 'सांगली', 'सतारा', 'सिंधुदुर्ग', 'सोलापुर', 'ठाणे', 'वर्धा', 'वाशिम', 'यवतमाल']
    }
  },
  'Manipur': {
    hi: 'मणिपुर',
    districts: {
      en: ['Imphal East', 'Imphal West', 'Thoubal', 'Bishnupur', 'Churachandpur', 'Chandel', 'Senapati', 'Ukhrul', 'Tamenglong', 'Kakching'],
      hi: ['इंफाल पूर्व', 'इंफाल पश्चिम', 'थौबल', 'बिष्णुपुर', 'चुराचांदपुर', 'चंदेल', 'सेनापति', 'उखरूल', 'तमेंगलोंग', 'काकचिंग']
    }
  },
  'Meghalaya': {
    hi: 'मेघालय',
    districts: {
      en: ['East Khasi Hills', 'West Khasi Hills', 'East Garo Hills', 'West Garo Hills', 'Jaintia Hills', 'Ri Bhoi', 'South Garo Hills'],
      hi: ['पूर्व खासी हिल्स', 'पश्चिम खासी हिल्स', 'पूर्व गारो हिल्स', 'पश्चिम गारो हिल्स', 'जैंतिया हिल्स', 'री भोई', 'दक्षिण गारो हिल्स']
    }
  },
  'Mizoram': {
    hi: 'मिजोरम',
    districts: {
      en: ['Aizawl', 'Lunglei', 'Champhai', 'Mamit', 'Kolasib', 'Serchhip', 'Lawngtlai', 'Saiha'],
      hi: ['आइजोल', 'लुंगलेई', 'चंफाई', 'ममित', 'कोलासिब', 'सेरछिप', 'लॉन्गतलाई', 'सइहा']
    }
  },
  'Nagaland': {
    hi: 'नागालैंड',
    districts: {
      en: ['Kohima', 'Dimapur', 'Mokokchung', 'Mon', 'Zunheboto', 'Wokha', 'Phek', 'Tuensang', 'Longleng', 'Kiphire'],
      hi: ['कोहिमा', 'दीमापुर', 'मोकोकचुंग', 'मोन', 'जुन्हेबोटो', 'वोखा', 'फेक', 'त्युएनसांग', 'लोंगलेंग', 'किफिरे']
    }
  },
  'Odisha': {
    hi: 'ओडिशा',
    districts: {
      en: ['Bhubaneswar', 'Cuttack', 'Puri', 'Berhampur', 'Rourkela', 'Sambalpur', 'Balasore', 'Baripada', 'Angul', 'Dhenkanal'],
      hi: ['भुवनेश्वर', 'कटक', 'पुरी', 'बेरहामपुर', 'राउरकेला', 'संबलपुर', 'बालासोर', 'बारीपदा', 'अंगुल', 'ढेंकनाल']
    }
  },
  'Punjab': {
    hi: 'पंजाब',
    districts: {
      en: ['Chandigarh', 'Ludhiana', 'Amritsar', 'Jalandhar', 'Patiala', 'Bathinda', 'Hoshiarpur', 'Mohali', 'Pathankot', 'Moga'],
      hi: ['चंडीगढ़', 'लुधियाना', 'अमृतसर', 'जालंधर', 'पटियाला', 'बठिंडा', 'होशियारपुर', 'मोहाली', 'पठानकोट', 'मोगा']
    }
  },
  'Rajasthan': {
    hi: 'राजस्थान',
    districts: {
      en: ['Jaipur', 'Jodhpur', 'Udaipur', 'Kota', 'Ajmer', 'Bikaner', 'Alwar', 'Bharatpur', 'Pali', 'Sikar'],
      hi: ['जयपुर', 'जोधपुर', 'उदयपुर', 'कोटा', 'अजमेर', 'बीकानेर', 'अलवर', 'भरतपुर', 'पाली', 'सीकर']
    }
  },
  'Sikkim': {
    hi: 'सिक्किम',
    districts: {
      en: ['East Sikkim', 'West Sikkim', 'North Sikkim', 'South Sikkim'],
      hi: ['पूर्व सिक्किम', 'पश्चिम सिक्किम', 'उत्तर सिक्किम', 'दक्षिण सिक्किम']
    }
  },
  'Tamil Nadu': {
    hi: 'तमिल नाडु',
    districts: {
      en: ['Chennai', 'Coimbatore', 'Madurai', 'Tiruchirappalli', 'Salem', 'Tirunelveli', 'Erode', 'Vellore', 'Thoothukudi', 'Thanjavur'],
      hi: ['चेन्नई', 'कोयम्बटूर', 'मदुरै', 'तिरुचिरापल्ली', 'सलेम', 'तिरुनेलवेली', 'इरोड', 'वेल्लोर', 'तूतुकुडी', 'तंजावुर']
    }
  },
  'Telangana': {
    hi: 'तेलंगाना',
    districts: {
      en: ['Hyderabad', 'Warangal', 'Nizamabad', 'Karimnagar', 'Ramagundam', 'Khammam', 'Mahbubnagar', 'Nalgonda', 'Adilabad', 'Medak'],
      hi: ['हैदराबाद', 'वारंगल', 'निजामाबाद', 'करीमनगर', 'रामागुंडम', 'खम्मम', 'महबूबनगर', 'नलगोंडा', 'आदिलाबाद', 'मेदक']
    }
  },
  'Tripura': {
    hi: 'त्रिपुरा',
    districts: {
      en: ['West Tripura', 'South Tripura', 'North Tripura', 'Dhalai', 'Khowai', 'Gomati', 'Sepahijala', 'Unakoti'],
      hi: ['पश्चिम त्रिपुरा', 'दक्षिण त्रिपुरा', 'उत्तर त्रिपुरा', 'धलाई', 'खोवाई', 'गोमती', 'सेपाहिजला', 'उनाकोटी']
    }
  },
  'Uttar Pradesh': {
    hi: 'उत्तर प्रदेश',
    districts: {
      en: ['Agra', 'Aligarh', 'Allahabad', 'Ambedkar Nagar', 'Amethi', 'Amroha', 'Auraiya', 'Azamgarh', 'Baghpat', 'Bahraich', 'Ballia', 'Balrampur', 'Banda', 'Barabanki', 'Bareilly', 'Basti', 'Bhadohi', 'Bijnor', 'Budaun', 'Bulandshahr', 'Chandauli', 'Chitrakoot', 'Deoria', 'Etah', 'Etawah', 'Faizabad', 'Farrukhabad', 'Fatehpur', 'Firozabad', 'Gautam Buddha Nagar', 'Ghaziabad', 'Ghazipur', 'Gonda', 'Gorakhpur', 'Hamirpur', 'Hapur', 'Hardoi', 'Hathras', 'Jalaun', 'Jaunpur', 'Jhansi', 'Kannauj', 'Kanpur Dehat', 'Kanpur Nagar', 'Kasganj', 'Kaushambi', 'Kushinagar', 'Lakhimpur Kheri', 'Lalitpur', 'Lucknow', 'Maharajganj', 'Mahoba', 'Mainpuri', 'Mathura', 'Mau', 'Meerut', 'Mirzapur', 'Moradabad', 'Muzaffarnagar', 'Pilibhit', 'Pratapgarh', 'Raebareli', 'Rampur', 'Saharanpur', 'Sambhal', 'Sant Kabir Nagar', 'Shahjahanpur', 'Shamli', 'Shravasti', 'Siddharthnagar', 'Sitapur', 'Sonbhadra', 'Sultanpur', 'Unnao', 'Varanasi'],
      hi: ['आगरा', 'अलीगढ़', 'इलाहाबाद', 'अम्बेडकर नगर', 'अमेठी', 'अमरोहा', 'औरैया', 'आजमगढ़', 'बागपत', 'बहराइच', 'बलिया', 'बलरामपुर', 'बाँदा', 'बाराबंकी', 'बरेली', 'बस्ती', 'भदोही', 'बिजनौर', 'बदायूं', 'बुलन्दशहर', 'चन्दौली', 'चित्रकूट', 'देवरिया', 'एटा', 'इटावा', 'फैजाबाद', 'फर्रुखाबाद', 'फतेहपुर', 'फिरोजाबाद', 'गौतम बुद्ध नगर', 'गाजियाबाद', 'गाजीपुर', 'गोंडा', 'गोरखपुर', 'हमीरपुर', 'हापुड़', 'हरदोई', 'हाथरस', 'जालौन', 'जौनपुर', 'झाँसी', 'कन्नौज', 'कानपुर देहात', 'कानपुर नगर', 'कासगंज', 'कौशाम्बी', 'कुशीनगर', 'लखीमपुर खीरी', 'ललितपुर', 'लखनऊ', 'महाराजगंज', 'महोबा', 'मैनपुरी', 'मथुरा', 'मऊ', 'मेरठ', 'मिर्जापुर', 'मुरादाबाद', 'मुजफ्फरनगर', 'पीलीभीत', 'प्रतापगढ़', 'रायबरेली', 'रामपुर', 'सहारनपुर', 'संभल', 'संत कबीर नगर', 'शाहजहाँपुर', 'शामली', 'श्रावस्ती', 'सिद्धार्थनगर', 'सीतापुर', 'सोनभद्र', 'सुल्तानपुर', 'उन्नाव', 'वाराणसी']
    }
  },
  'Uttarakhand': {
    hi: 'उत्तराखंड',
    districts: {
      en: ['Dehradun', 'Haridwar', 'Haldwani', 'Nainital', 'Roorkee', 'Rishikesh', 'Rudrapur', 'Almora', 'Pithoragarh', 'Pauri'],
      hi: ['देहरादून', 'हरिद्वार', 'हल्द्वानी', 'नैनीताल', 'रुड़की', 'ऋषिकेश', 'रुद्रपुर', 'अल्मोड़ा', 'पिथौरागढ़', 'पौड़ी']
    }
  },
  'West Bengal': {
    hi: 'पश्चिम बंगाल',
    districts: {
      en: ['Alipurduar', 'Bankura', 'Birbhum', 'Cooch Behar', 'Dakshin Dinajpur', 'Darjeeling', 'Hooghly', 'Howrah', 'Jalpaiguri', 'Jhargram', 'Kalimpong', 'Kolkata', 'Malda', 'Murshidabad', 'Nadia', 'North 24 Parganas', 'Paschim Bardhaman', 'Paschim Medinipur', 'Purba Bardhaman', 'Purba Medinipur', 'Purulia', 'South 24 Parganas', 'Uttar Dinajpur'],
      hi: ['अलीपुरद्वार', 'बांकुरा', 'बीरभूम', 'कूच बिहार', 'दक्षिण दिनाजपुर', 'दार्जिलिंग', 'हुगली', 'हावड़ा', 'जलपाईगुड़ी', 'झारग्राम', 'कलिम्पोंग', 'कोलकाता', 'मालदा', 'मुर्शिदाबाद', 'नदिया', 'उत्तर 24 परगना', 'पश्चिम बर्धमान', 'पश्चिम मेदिनीपुर', 'पूर्व बर्धमान', 'पूर्व मेदिनीपुर', 'पुरुलिया', 'दक्षिण 24 परगना', 'उत्तर दिनाजपुर']
    }
  }
};